import React from "react";
import { Button } from "../../components/forms/Form";

export default function InfoItem(props) {
  // console.log(props);
  return (
    <div className="info-item">
      <label>{props.label}</label>
      <input
        onChange={(event) =>
          props.handleChangeInput(props.target, event.target.value)
        }
        defaultValue={props.defaultValue || ""}
        type={props.type}
        placeholder={props.placeholder}
        disabled={props.disabled}
      ></input>
      {props.button ? (
        <div>
          <Button
            className={"circle-button"}
            handleSubmit={props.button.handleClick}
            loading={props.button.loading}
            text={props.button.text}
          />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}
